
import { QForm } from 'quasar';
import { computed, defineComponent, Ref, ref } from 'vue';
import useValidation from 'SharedDir/common/composables/useValidation';
import { PHONE_PATTERN } from 'SharedDir/utils/helpers';
import { Feedback } from 'SharedDir/declarations/feedback';
import SBtn from 'SharedDir/components/ui/Button/SBtn.vue';
import { useLoading } from 'SharedDir/common/composables/useLoading';
import { useNotifications } from 'SharedDir/common/composables/useNotifications';
import FeedbackApiClass from 'SharedDir/backend/api/classes/FeedbackApiClass';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { useYandexCaptcha } from 'SharedDir/common/composables/useYandexCaptcha';
import YandexCaptcha from 'SharedDir/components/ui/YandexCaptcha.vue';

import PortalDialog from '../base/PortalDialog.vue';

export default defineComponent({
  name: 'FeedbackModal',
  props: {
    show: {
      type: Boolean,
    },
  },
  components: {
    PortalDialog,
    SBtn,
    YandexCaptcha,
  },
  setup(props, { emit }) {
    const { action } = useLoading();
    const $notification = useNotifications();
    const { NotEmpty, MinLength, CheckRegex, ValidEmail, ValidPhone } = useValidation();
    const { general: loading } = useLoading();
    const requestOptions = {
      startLoading: action.show,
      finishLoading: action.hide,
    };
    const {
      showCaptcha,
      banner,
      validationState,
      checkCaptchaValidation
    } = useYandexCaptcha();

    const formData = ref({
      lastName: '',
      firstName: '',
      middleName: '',
      email: '',
      phone: '',
      description: '',
    }) as Ref<Feedback>;
    const refForm = ref(QForm);

    const clearFormData = () => {
      formData.value = {
        lastName: '',
        firstName: '',
        middleName: '',
        email: '',
        phone: '',
        description: '',
      };
    };

    const modalShow = computed({
      get: () => props.show,
      set: (value) => {
        clearFormData();
        emit('update:show', value);
      },
    });

    const onSubmit = async () => {
      const isValidForm: boolean = await refForm.value.validate();
      if (!isValidForm) {
        $notification.warningNotification('Необходимо заполнить обязательные поля');
        return;
      }

      if (showCaptcha.value && !validationState.value) {
        await checkCaptchaValidation();
      }

      const response = await makeRequest(async () =>
        FeedbackApiClass.create(formData.value), requestOptions);

      if (response) {
        $notification.successNotification('Ваша обращение успешно отправлено');
        modalShow.value = false;
      }
    };
    return {
      PHONE_PATTERN,
      NotEmpty,
      MinLength,
      CheckRegex,
      ValidEmail,
      ValidPhone,
      loading,
      modalShow,
      formData,
      refForm,
      onSubmit,
      showCaptcha,
      banner,
    };
  },
});
